export default function () {
  return {
    skip: 1,
    atBeginning: false,
    atEnd: false,
    currentSlide: null,

    next() {
      if (this.atEnd) return;
      this.to((current, offset) => current + (offset * this.skip))
    },

    prev() {
      if (this.atBeginning) return;
      this.to((current, offset) => current - (offset * this.skip))
    },

    to(strategy) {
      const slider = this.$refs.slider
      const current = slider.scrollLeft
      const offset = slider.firstElementChild.getBoundingClientRect().width

      // Fade slide out then scroll to next slide.
      this.currentSlide?.classList.replace('opacity-100', 'opacity-0')
      this.currentSlide.addEventListener('transitionend', () => {
        slider.scrollTo({ left: strategy(current, offset), behavior: 'instant' })
      }, { once: true })
    },

    disableNextAndPreviousButtons: {
      'x-intersect:enter.threshold.05'() {
        const slideEls = this.$el.parentElement.children
        this.currentSlide = this.$el // set slide so it can be faded out later
        setTimeout(() => {
          this.$el.classList.replace('opacity-0', 'opacity-100')
        }, 100);

        // If this is the first slide.
        if (slideEls[0] === this.$el) {
          this.atBeginning = true
        // If this is the last slide.
        } else if (slideEls[slideEls.length-1] === this.$el) {
          this.atEnd = true
        }
      },

      'x-intersect:leave.threshold.05'() {
        const slideEls = this.$el.parentElement.children

        // If this is the first slide.
        if (slideEls[0] === this.$el) {
          this.atBeginning = false
        // If this is the last slide.
        } else if (slideEls[slideEls.length-1] === this.$el) {
          this.atEnd = false
        }
      },
    },
  }
}
